import * as React from "react";
import { useCallback } from "react";
import URI from "urijs";
import { Button } from "components/bootstrap";
import { reportingUrl } from "report/Constants";
import ButtonToolbar from "components/bootstrap/ButtonToolbar";
import useSendTelemetry from "logic/telemetry/useSendTelemetry";
import { TELEMETRY_EVENT_TYPE } from "telemetry/Constants";
import Icon from "components/common/Icon";
import useSendIlluminateReportDownloadedTelemetry from "report/hooks/useSendIlluminateReportDownloadedTelemetry";
const downloadUrl = (reportId, jobId) => new URI(reportingUrl(`${reportId}/history/${jobId}/download`)).toString();
const ReportHistoryActions = ({ report, reportHistory }) => {
  const sendTelemetry = useSendTelemetry("report-history");
  const sendIlluminateReportDownloaded = useSendIlluminateReportDownloadedTelemetry("report-history");
  const onDownload = useCallback(() => {
    sendTelemetry(TELEMETRY_EVENT_TYPE.REPORT.DOWNLOAD, {
      app_pathname: "report"
    });
    sendIlluminateReportDownloaded(report);
  }, [report, sendIlluminateReportDownloaded, sendTelemetry]);
  return /* @__PURE__ */ React.createElement(ButtonToolbar, null, reportHistory.has_asset && /* @__PURE__ */ React.createElement("a", { key: "configuration-button", href: downloadUrl(report.id, reportHistory.id), rel: "noopener noreferrer" }, /* @__PURE__ */ React.createElement(Button, { disabled: !reportHistory.has_asset, bsSize: "xsmall", onClick: onDownload }, /* @__PURE__ */ React.createElement(Icon, { name: "download" }), " Download")));
};
export default ReportHistoryActions;
